export default "__VITE_PUBLIC_ASSET__396338d0__"